export const formatCurrency = (
  value: number | undefined,
  _locale: string = "en",
  minimumFractionDigits: number = 2,
): string => {
  const formattedValue = new Intl.NumberFormat(
    "en-CA",
    // locale === "fr" ? "fr-CA" : "en-CA",
    {
      style: "currency",
      currency: "CAD",
      minimumFractionDigits: minimumFractionDigits,
      maximumFractionDigits: 2,
    },
  ).format(value ?? 0);

  return formattedValue.replace(/,/g, " ");
};

export const formatDate = (
  date: string | undefined,
  locale: string = "en",
): string => {
  if (!date) return "";

  // Calendar dates coming from the API ("2025-11-01" or "2025-11-01T00:00:00Z")
  // must not be shifted by the browser timezone: `new Date("2025-11-01")` is
  // parsed as UTC midnight, which renders as October 31 anywhere west of UTC.
  // Take the calendar parts as-is and format them in UTC.
  const calendarDate = date.match(/^(\d{4})-(\d{2})-(\d{2})/);

  const dateObj = calendarDate
    ? new Date(
        Date.UTC(
          Number(calendarDate[1]),
          Number(calendarDate[2]) - 1,
          Number(calendarDate[3]),
        ),
      )
    : new Date(date);

  // Check if date is valid
  if (isNaN(dateObj.getTime())) return "";

  return new Intl.DateTimeFormat(locale === "fr" ? "fr-FR" : "en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: calendarDate ? "UTC" : undefined,
  }).format(dateObj);
};

/**
 * A precise moment rather than a calendar date — a deadline the customer has to
 * act before — so it is rendered in their own timezone, clock time included.
 */
export const formatTime = (
  date: string | undefined,
  locale: string = "en",
): string => {
  if (!date) return "";

  const dateObj = new Date(date);

  if (isNaN(dateObj.getTime())) return "";

  return new Intl.DateTimeFormat(locale === "fr" ? "fr-FR" : "en-US", {
    hour: "numeric",
    minute: "2-digit",
  }).format(dateObj);
};
